import { render, staticRenderFns } from "./process-and-transfer-details-card.vue?vue&type=template&id=6190e438"
import script from "./process-and-transfer-details-card.vue?vue&type=script&lang=js"
export * from "./process-and-transfer-details-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports